var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionCtaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 4,
    viewBox: "0 0 16 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1367 2C13.1367 1.58579 13.4707 1.25 13.8827 1.25C14.2947 1.25 14.6287 1.58579 14.6287 2C14.6287 2.41421 14.2947 2.75 13.8827 2.75C13.4707 2.75 13.1367 2.41421 13.1367 2Z",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16866 2C7.16866 1.58579 7.50266 1.25 7.91466 1.25C8.32667 1.25 8.66066 1.58579 8.66066 2C8.66066 2.41421 8.32667 2.75 7.91466 2.75C7.50266 2.75 7.16866 2.41421 7.16866 2Z",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.20066 2C1.20066 1.58579 1.53466 1.25 1.94666 1.25C2.35867 1.25 2.69266 1.58579 2.69266 2C2.69266 2.41421 2.35867 2.75 1.94666 2.75C1.53466 2.75 1.20066 2.41421 1.20066 2Z",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionCtaIcon);
export default __webpack_public_path__ + "static/media/action-cta-icon.9aa5a6fa12175735120326c5a810140f.svg";
export { ForwardRef as ReactComponent };